import React, {useEffect} from 'react'
import Navbar from '../components/Navbar';
import ProjectShower from '../components/ProjectShower';

export default function Project() {

  useEffect(() => {
    const scroller = document.body
    scroller.scrollIntoView({ behavior: 'smooth' })
    scroller.scrollTo(0, 0)
  }, []);

  return (
    <>
  <div className="NavbarStyle" >
        <Navbar />
      </div>
      
    <ProjectShower/>
  </>
  )
}
